export const SUPPORT_ERROR_OFFER_EVENT = "newera:offer-support-error-report";

/** Fire-and-forget; SupportErrorOfferHost listens (safe to import from api layer). */
export function offerSupportErrorReport(detail) {
  if (!detail || typeof detail !== "object") return;
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SUPPORT_ERROR_OFFER_EVENT, { detail }));
}
